export const actionTypes = {
  SET_FAQ_LIST: "SET_FAQ_LIST",
  SET_FAQ_ALL_LIST: "SET_FAQ_ALL_LIST",
  SET_FAQ_TREE: "SET_FAQ_TREE",
  SET_FAQ_DETAIL: "SET_FAQ_DETAIL",
  SET_FAQ_ALL_DETAIL: "SET_FAQ_ALL_DETAIL",
};